import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Clock, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';

const Success = () => {
  const [registrationData, setRegistrationData] = useState(null);

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('tutorRegistration') || '{}');
    setRegistrationData(data);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-teal-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Success Card */}
        <Card className="p-8 md:p-12 bg-white shadow-xl border-gray-100 text-center">
          {/* Success Icon */}
          <div className="mb-8">
            <div className="w-24 h-24 bg-gradient-to-br from-green-500 to-teal-500 rounded-full flex items-center justify-center mx-auto shadow-2xl animate-pulse">
              <CheckCircle className="h-14 w-14 text-white" />
            </div>
          </div>

          {/* Success Message */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Application Submitted Successfully!
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Thank you for applying to become a tutor on PriEdu
          </p>

          {/* Illustration */}
          <div className="mb-8">
            <img
              src="https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxvbmxpbmUlMjB0dXRvcmluZ3xlbnwwfHx8fDE3NjI0Mzk3MTh8MA&ixlib=rb-4.1.0&q=85"
              alt="Success"
              className="rounded-2xl shadow-lg mx-auto max-w-md w-full"
            />
          </div>

          {/* Info Box */}
          <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl p-6 mb-8 border border-blue-200">
            <div className="flex items-start space-x-4">
              <div className="bg-gradient-to-br from-blue-600 to-teal-500 p-3 rounded-xl flex-shrink-0">
                <Clock className="h-6 w-6 text-white" />
              </div>
              <div className="text-left">
                <h3 className="font-bold text-gray-900 mb-2">What's Next?</h3>
                <ul className="space-y-2 text-sm text-gray-700">
                  <li className="flex items-start">
                    <span className="text-blue-600 mr-2">•</span>
                    <span>Our team will review your profile and documents</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 mr-2">•</span>
                    <span>Background verification will be conducted</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 mr-2">•</span>
                    <span>You'll receive an email within 24-48 hours</span>
                  </li>
                  <li className="flex items-start">
                    <span className="text-blue-600 mr-2">•</span>
                    <span>Once approved, you can start teaching!</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Estimated Time */}
          <div className="mb-8">
            <p className="text-gray-600">
              <span className="font-semibold text-gray-900">Estimated Approval Time:</span>{' '}
              24-48 hours
            </p>
          </div>

          {/* Test Results (if available) */}
          {registrationData?.testResults && (
            <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-xl p-6 mb-8 border border-green-200">
              <h3 className="font-bold text-gray-900 mb-3">Your Test Results</h3>
              <div className="flex items-center justify-center space-x-8">
                <div>
                  <div className="text-3xl font-bold text-green-600">
                    {registrationData.testResults.score}/{registrationData.testResults.total}
                  </div>
                  <div className="text-sm text-gray-600">Questions Correct</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-teal-600">
                    {Math.round(registrationData.testResults.percentage)}%
                  </div>
                  <div className="text-sm text-gray-600">Score</div>
                </div>
              </div>
            </div>
          )}

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button className="bg-gradient-to-r from-blue-600 to-teal-500 hover:from-blue-700 hover:to-teal-600 text-white px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all duration-300 w-full sm:w-auto">
                <Home className="mr-2 h-5 w-5" />
                Go to Home
              </Button>
            </Link>
            <Button
              variant="outline"
              className="border-blue-300 text-blue-700 hover:bg-blue-50 px-8 py-6 text-lg w-full sm:w-auto"
              onClick={() => window.open('mailto:support@priedu.com')}
            >
              Contact Support
            </Button>
          </div>
        </Card>

        {/* Additional Info */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-600">
            Questions? Email us at{' '}
            <a href="mailto:support@priedu.com" className="text-blue-600 hover:text-blue-700 font-medium">
              support@priedu.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Success;